import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { CrudService } from '../../crud/crud.service';
import { environment } from '../../../environments/environment';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Title } from '@angular/platform-browser';
import { saveAs } from 'file-saver';
import * as moment from 'moment';

import * as JSZip from 'jszip';

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';

@Component({
  selector: 'app-filtros-reportes',
  templateUrl: 'filtros-reportes.component.html'
})

export class FiltrosReportesComponent implements OnInit{
  @Input() ruta: string;
  @Input() datos: any[];
  @Input() cargando: boolean;

  error_busqueda = false;
  sin_resultado = '';
  rangos_fecha;
  carpeta;
  modulo;
  grupo;
  carrera;
  estatus;
  controlador;
  controller;
  modulo_actual;
  actual;
  icono;

  permisos = JSON.parse(localStorage.getItem("permisos"));

  activarReporte = false;

  date = new Date();
  MinDate = new Date(this.date.getFullYear(), this.date.getMonth(), 1);

  fecha_desde = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);
  fecha_actual = new Date(this.date.getFullYear(), this.date.getMonth() + 1, this.date.getDate());

  desde = this.date.getFullYear() + '-' + (this.date.getMonth() + 1) + '-' + '1';
  hasta = this.date.getFullYear() + '-' + (this.date.getMonth() + 1) + '-' + this.date.getDate();
  rango = '';
  tipo = 0;
  texto = '';

  configuracion = JSON.parse(localStorage.getItem('configuracion'));

  niveles_educativos = [];
  logos64;

  constructor(
    private crudService: CrudService,
    private route: ActivatedRoute,
    private title: Title,
    private fb: FormBuilder,
    private _sanitizer: DomSanitizer) { }

  ngOnInit() {

    this.rangos_fecha = [
      { 'id': '', 'nombre': 'Fecha desde - hasta' },
      { 'id': moment().format('YYYY-MM-DD') + '/' + moment().format('YYYY-MM-DD'), 'nombre': 'Hoy' },
      { 'id': moment().subtract(1, 'days').format('YYYY-MM-DD') + '/' + moment().subtract(1, 'days').format('YYYY-MM-DD'), 'nombre': 'Ayer' },
      { 'id': moment().subtract(7, 'days').format('YYYY-MM-DD') + '/' + moment().format('YYYY-MM-DD'), 'nombre': 'Últimos 7 días' },
      { 'id': moment().startOf('month').format('YYYY-MM-DD') + '/' + moment().endOf('month').format('YYYY-MM-DD'), 'nombre': 'Este mes' },
      { 'id': moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD') + '/' + moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'), 'nombre': 'Mes pasado' },
      { 'id': moment().startOf('year').format('YYYY-MM-DD') + '/' + moment().endOf('year').format('YYYY-MM-DD'), 'nombre': 'Este año' },
      { 'id': moment().subtract(1, 'years').startOf('year').format('YYYY-MM-DD') + '/' + moment().subtract(1, 'years').endOf('year').format('YYYY-MM-DD'), 'nombre': 'Año pasado' },
      { 'id': moment('1969-01-01', 'YYYY-MM-DD', true).format('YYYY-MM-DD') + '/' + moment().format('YYYY-MM-DD'), 'nombre': 'Todos los tiempos' }
    ];



    let url = location.href.split("/");
    this.carpeta = url[4];
    this.modulo = url[5];
    this.actual = url[6];

    //this.modulo_actual = this.modulo.replace(/[-](?:^|\s)\S/g, function(a) { return a.toUpperCase(); }).replace(/[-_]+/g, ' ');

    let ctrl = "-" + this.modulo;
    this.controlador = ctrl.toLowerCase()
      // remplazar _ o - por espacios
      .replace(/[-_]+/g, ' ')
      // quitar numeros
      .replace(/[^\w\s]/g, '')
      // cambiar a mayusculas el primer caracter despues de un espacio
      .replace(/ (.)/g, function ($1) {
        return $1.toUpperCase();
      })
      // quitar espacios y agregar controller
      .replace(/ /g, '');
    let subtitulo = this.controlador;
    this.controller = 'Reporte' + this.controlador + 'Controller';
    this.controlador = 'Reporte' + this.controlador + 'Controller' + 'index';
    let menu = JSON.parse(localStorage.getItem("menu"));

    let titulo_icono = this.obtener_icono(url, this.controlador, menu);

    this.icono = titulo_icono.icono;
    this.modulo_actual = subtitulo + ' ' + titulo_icono.titulo;

    this.title.setTitle('Reportes ' + subtitulo);

    this.obtenerCatalogos('logos64', 'logos64', 'logo64');
  }

  obtener_icono(url, controlador, menu) {
    menu.map((element, key) => {
      if (typeof this.icono == 'undefined') {
        if (element.lista) {
          this.icono = this.obtener_icono(url, controlador, element.lista);
          return this.icono;
        }
        if (element.path.indexOf(url[5] + '/' + url[6]) > -1) {

          this.icono = element;
          return this.icono;
        }
      }
      else
        return this.icono;
    });
    return this.icono;
  }


  buscar() {
    this.cargando = true;
    this.datos = [];
    let json: any = {
      rango: this.rango,
      desde: this.desde,
      hasta: this.hasta,
      tipo: this.tipo,
      texto: this.texto
    };
    if(this.grupo != '')
      json.grupo = this.grupo;

    if(this.carrera != '')
      json.carrera = this.carrera;

    if(this.estatus != '')
      json.estatus = this.estatus;

    this.crudService.crear(json, 'reporte/' + this.ruta).subscribe(
      resultado => {
        this.cargando = false;
        // se encontro resultado
        if (resultado.status === 200) {
          for (const key in resultado) {
            if (resultado.hasOwnProperty(key)) {
              const element = resultado[key];
              this[key] = element;
            }
          }

        } else {
          this.sin_resultado = resultado.messages;
          setTimeout(() => {
            this.sin_resultado = '';
          }, 3500);
        }
        this.error_busqueda = false;
      },
      error => {
        this.cargando = false;
        this.error_busqueda = true;
        setTimeout(() => {
          this.error_busqueda = false;
        }, 3500);
      }
    );
  }
  parametros = {
    pagina: 0,
    limite: 0
  };
  obtenerCatalogos(url, model, id = '') {
    this.crudService.lista(this.parametros, url).subscribe(
      resultado => {
        this[model] = resultado.data;
        if (id != '') {
          document.getElementById(id).click();
        }
      },
      error => {
      }
    );
  }

  zip_xml(datos){
    const jszip = new JSZip();
    datos.forEach(element => {
      jszip.file(element.uuid + '.xml', element.xml);
    });

    jszip.generateAsync({ type: 'blob' }).then(function (content) {
      saveAs(content, 'facturacion_xml.zip');
    });
  }

  imprimir() {
    let titulo = 'Reporte ' + this.modulo_actual;

    let doc = new jsPDF("landscape", "mm", "letter");

    let logo = this.logo_sucursal != '' ? this.logo_sucursal : this.logo_empresa;
    if (logo != '' && logo != undefined && logo != null)
      doc.addImage(logo, "PNG", 10, 5, 25, 20, "left", "FAST");

    let linea = 22;
    //Header
    doc.setFontSize(15);
    doc.setFont("helvetica", "", "bold");
    doc.setFont("helvetica");
    doc.text(this.configuracion.empresa.nombre, 140, 12, {align:"center"});

    doc.setFontSize(14);
    doc.setFont("helvetica", "", "bold");
    doc.text(this.configuracion.empresa.subnombre, 140, 18, {align:"center"});

    linea += 4;
    doc.setFontSize(10);
    doc.setFont("helvetica", "", "bold");
    doc.text(this.configuracion.sucursal.direccion.split(",")[0], 140, linea,  {align:"center"});
    linea += 4;
    doc.text(this.configuracion.sucursal.direccion.split(",")[1], 140, linea, {align:"center"});
    linea += 4;
    doc.text("RFC: " + this.configuracion.sucursal.facturacion.rfc, 140, linea, {align:"center"});
    linea += 6;

    doc.setFont("helvetica", "", "bold");
    doc.setFontSize(6);
    doc.text('------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------', 144, linea, {align:"center"});
    linea += 6;

    doc.setFontSize(12);
    doc.text( titulo, 140, linea, {align:'center'});
    linea += 6;

    let elem = document.getElementById("tabla");
    let data = (doc as any).autoTableHtmlToJson(elem);

    (doc as any).autoTable(data.columns, data.rows, {
      didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
        cell.styles.fillColor = "#ffffff";
      },
      startY: linea,
      styles: {
        fontSize: 6, font: "helvetica",
        halign: "center",
        fillColor: "#FFFFFF",
        textColor: "#000000",
        lineColor: "#000000",
        lineWidth: 0.3
      },
      headStyles: {
        lineColor: "#000000",
        lineWidth: 0.3
      },
      tableWidth: 'auto',
      margin: { right: 10, left: 10 },
    });
    linea += 6.5 * this.datos.length + 5;
    if (document.getElementById("tabla2")){
      elem = document.getElementById("tabla2");
      data = (doc as any).autoTableHtmlToJson(elem);
      console.log(data);
      
      (doc as any).autoTable(data.columns, data.rows, {
        didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
          cell.styles.fillColor = "#ffffff";
        },
        startY: linea,
        styles: {
          fontSize: 6, font: "helvetica",
          halign: "center",
          fillColor: "#FFFFFF",
          textColor: "#000000",
          lineColor: "#000000",
          lineWidth: 0.3,
          fontStyle:'bold'
        },
        headStyles: {
          lineColor: "#000000",
          lineWidth: 0.3
        },
        tableWidth: 'auto',
        margin: { right: 10, left: 10 },
      });

      linea += 20;
    }

    if (this.niveles_educativos.length > 0) {
      elem = document.getElementById("tabla3");
      data = (doc as any).autoTableHtmlToJson(elem);

      (doc as any).autoTable(data.columns, data.rows, {
        didParseCell : function (cell) {
              let data= cell;
              cell = cell.cell;
          cell.styles.fillColor = "#ffffff";
        },
        startY: linea,
        styles: {
          fontSize: 6, font: "helvetica",
          halign: "center",
          fillColor: "#FFFFFF",
          textColor: "#000000",
          lineColor: "#000000",
          lineWidth: 0.3
        },
        headStyles: {
          lineColor: "#000000",
          lineWidth: 0.3
        },
        tableWidth: 'auto',
        margin: { right: 10, left: 10 },
      });

      linea += 8 * this.niveles_educativos.length;
    }

    // doc.autoPrint();
    //const string = (doc as any).output('datauristring', titulo + '.pdf');
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + string + "'></iframe>"

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/
  }

  excel() {
    let colspan = document.getElementsByTagName('table')[0].children[0].children[0].childElementCount;
    let titulo = 'Reporte ' + this.modulo_actual;
    let excelData = "<table><tr><th colspan='" + colspan + "'><h1>" + titulo + " <h1></th></tr></table>";
    let html = document.getElementById('imprimir').innerHTML;
    html = html.replace(/\$/g, '');
    excelData += html;
    let blob = new Blob([excelData], { type: "text/comma-separated-values;charset=utf-8" });
    saveAs(blob, titulo + ".xls");
  }

  logo_sucursal;
  logo_empresa;

  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
    }
  }
}
